import React from 'react';
import styled from 'styled-components';

const VideoWrap = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background: #000000;
`;

const VideoFrame = styled.iframe`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
`;

const VideoDisplay = () => {
  return (
    <VideoWrap>
      <VideoFrame
        src="https://www.youtube.com/embed/9-IiSMi_W_I?si=jUnaxqQD9ATPoWnw&autoplay=1&mute=1"
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </VideoWrap>
  );
};

export default VideoDisplay;
